import {useNavigation, useRoute} from '@react-navigation/core';
import React, {useEffect, useState, useRef} from 'react';
import {
   View,
   StyleSheet,
   SafeAreaView,
   Alert,
   StatusBar,
   Platform,
   DeviceEventEmitter,
   NativeModules,
} from 'react-native';
import {
   apiGetCourseList,
   apiGetOfllineCourses,
   apiPostRequest,
   apiPostService,
   showTokenExpireAlertWeb,
} from '../../service/network_access';
import {
   LOGIN_TO_COURSE,
   RijindaelDecoction,
   myIBTAlert,
   isNewAPI,
   OFFLINE_VIDEO_PATH,
   isWeb,
   checkManifestFileExists,
   OFFLINE_COURSES_BASE_URL,
   isFoldeExistsAtDocumentDirecotory,
   isWindows,
   setWebNavTitle,
} from '../../utils/utils';
import CourseDetails from './CourseDetails';
import {
   drawerListBackgroundColor,
   downloadViewColor,
   getLoginToCourseParams,
} from '../../utils/utils';
import DownloadCourseScreen from './downloadCourse';
import {CustomStatusBar} from '../../utils/customStatusBar';
import {
   CourseModuleCompletedCount,
   ModuleAvailable,
   canPreTest,
   completeModuleEvaluation,
   isModuleAvailable,
} from '../../utils/course_utils';
import {useDispatch, useSelector} from 'react-redux';
import {
   selectedScratchPadRecord,
   setScratchPadRecord,
} from '../../redux/slices/ScratchPadRecordSlice';
import {selectAuthData, setSignIn} from '../../redux/slices/AuthSlice';
import logger from '../../utils/logger';
import {
   setCurrentRunningSlide,
   setModuleIndex,
   setModuleSlides,
} from '../../redux/slices/ModuleIndexSlice';
import {
   getCourseData,
   getEnrollPageReload,
   getParseJsonData,
   setCourseData,
   setModuleCompetedCount,
   setParseJsonData,
} from '../../redux/slices/EnrolledCourseDataSlice';
import RNFS from '../../components/fs';
import {selectDownloadPreference} from '../../redux/slices/DownloadPreferenceSlice';
import {setCommingFromDetails} from '../../redux/slices/TrackRoot';
const isDesktop = Platform.OS === 'macos' || Platform.OS === 'windows';
import {useIsFocused} from '@react-navigation/native';

export const CourseDetailsLoading = props => {
   const [loginCourse, setLoginCourse] = useState();
   const navigation = useNavigation();
   const [progress, setProgress] = useState(0);
   const dispatch = useDispatch();
   const authData = useSelector(selectAuthData);
   const enrolledCourseData = useSelector(getCourseData);
   const mParseJsonData = useSelector(getParseJsonData);
   const isPageReload = useSelector(getEnrollPageReload);
   const param = useRoute().params;
   const [isApiLoaded, setIsApiLoaded] = useState(
      Platform.OS == 'windows' && !isPageReload ? false : true,
   );
   const [parseJson, setParseJson] = useState(
      Platform.OS == 'windows' && !isPageReload ? mParseJsonData : null,
   );
   let courseData =
      Platform.OS == 'windows' && !isPageReload
         ? enrolledCourseData
         : param.courseData;
   const isMacos = Platform.OS === 'macos';
   var previous_progress = 0;
   const [isFileDownloaded, setIsFileDownloaded] = useState(false);
   const downloadProgressRef = useRef(progress);
   const isDownloadPreferenceEnabled = useSelector(selectDownloadPreference);
   const [firstNodeOfScrPad, setfirstNodeOfScrPad] = useState([]);
   const [scratchPadRecordData, setScratchPadRecordData] = useState();
   const isScreenFocused = useIsFocused();
   useEffect(() => {
      setWebNavTitle(
         navigation,
         isApiLoaded ? 'Course Loading' : 'Module Details',
      );
   }, [navigation, isApiLoaded]);
   useEffect(() => {
      downloadProgressRef.current = progress;
   }, [progress]);

   function readManifestFile(loginCourseClone) {
      //Read the mainfest.xc file from the doucment directory
      // Define the file path in the document directory
      const filePath =
         RNFS.DocumentDirectoryPath +
         '/Norcat/' +
         courseData.courseNameID +
         '/' +
         'manifest.xc';

      // Read the file
      RNFS.readFile(filePath, 'utf8')
         .then(fileData => {
            // Handle the file data here
            const resData = RijindaelDecoction({
               dcrText: fileData,
            });
            processManfiestData(resData, loginCourseClone);
         })
         .catch(error => {
            console.error('Error reading file:', error);
         });
   }

   function processManfiestData(resData, loginCourseClone) {
      //Pass the data to Rijindael
      dispatch(setCourseData(courseData));
      if (resData.responseCode !== 0) {
         try {
            const modifyData = completeModuleEvaluation({
               loginToCourse: loginCourseClone,
               courseDetails: resData.data,
            });
            const unCompletedModule = CourseModuleCompletedCount({
               loginToCourse: loginCourse,
               courseDetails: resData.data,
            });
            dispatch(setModuleCompetedCount(unCompletedModule));
            const x = JSON.parse(modifyData);
            if (Array.isArray(x.DataSet.courseModule.CourseModule)) {
               const mAvailable = ModuleAvailable({
                  courseDetails: x,
               });
               if (Platform.OS === 'windows') {
                  dispatch(setParseJsonData(mAvailable));
               }
               setParseJson(mAvailable);
            } else {
               if (Platform.OS === 'windows') {
                  dispatch(setParseJsonData(modifyData));
               }
               setParseJson(modifyData);
            }
            setIsApiLoaded(false);
         } catch (error) {
            logger(error);
         }
      } else {
         const message = resData.data;
         myIBTAlert({
            title: 'Error!',
            message: message,
            pCallBack: () => {
               navigation.goBack();
            },
         });
      }
   }

   useEffect(() => {
      if ((isWindows && isScreenFocused) || !isWindows) {
         if (courseData === 'undefined') {
            courseData = enrolledCourseData;
         }
         if (courseData === 'undefined') {
            navigation.goBack();
         }
         const downloadEventListener = DeviceEventEmitter.addListener(
            'DownloadEvent',
            notification => {
               const message = notification.status;
               logger('Received Notification:', message);
            },
         );
         const progressEventListener = DeviceEventEmitter.addListener(
            'ProgressEvent',
            notification => {
               const progress = notification.progress;
               logger('progress Notification: ', progress);
            },
         );
         if (Platform.OS === 'windows' && !isPageReload) {
            return;
         }
         // logger(`LOGIN TO COURSE:: ${courseData.courseNameID}`);
         const wwwCourse = courseData.courseNameID + '/manifest.xc';
         const loginToCourseUrl = LOGIN_TO_COURSE;
         var nCourseData;

         apiPostService({
            url: loginToCourseUrl,
            parms: getLoginToCourseParams(courseData, authData),
         })
            .then(res => res.data)
            .then(res => {
               const {ScratchPadRecordsList} = res;
               logger(
                  `ScratchPadRecordsList::${JSON.stringify(
                     ScratchPadRecordsList,
                  )}`,
               );
               if (courseData.pid === 'BUNDLE') {
                  var newCourseData = {
                     courseKey: courseData.courseKey,
                     courseName: courseData.courseName,
                     courseSaveCount: courseData.courseSaveCount,
                     courseStatus: courseData.courseStatus,
                     courseVersion: courseData.courseVersion,
                     courseduration: courseData.courseduration,
                     coursemodulecount: courseData.coursemodulecount,
                     coursename: courseData.coursename,
                     coursethumbnail: courseData.coursethumbnail,
                     coursevalidity: courseData.coursevalidity,
                     imageURL: courseData.imageURL,
                     loginid: ScratchPadRecordsList[0].UserID,
                     modulesCompleted: courseData.modulesCompleted,
                     pageCount: courseData.pageCount,
                     pageNumber: courseData.pageNumber,
                     pid: ScratchPadRecordsList[0].Password,
                     userKey: courseData.userKey,
                  }
                  nCourseData = newCourseData;
                  //return;
               }
               else {
                  nCourseData = courseData;
               }
               if (
                  ScratchPadRecordsList &&
                  ScratchPadRecordsList?.length === 0
               ) {
                  navigation.navigate('DashboardScreen');
                  return;
               } else {
                  setfirstNodeOfScrPad(ScratchPadRecordsList[0]);
               }
               if (
                  res !== null &&
                  res !== undefined &&
                  typeof res !== 'string' &&
                  res.ScratchPadRecordsList?.length > 0
               ) {
                  const loginCourse = JSON.stringify(res);
                  setLoginCourse(loginCourse);
                  const scratchPadRecord = {scratchPadRecord: loginCourse};
                  setScratchPadRecordData(scratchPadRecord);
                  dispatch(setScratchPadRecord(scratchPadRecord));
                  if (isDesktop && isDownloadPreferenceEnabled === 'true') {
                     //For the desktop version download the video locally
                     const name = courseData.courseNameID + '.zip';
                     const url = OFFLINE_COURSES_BASE_URL + name;

                     //MACOS native code integration
                     //setDownloadStart(true);
                     // NativeModules.DownloadModule.downloadAction(url, oncomplete => {
                     //    //setIsApiLoaded(false);
                     // });

                     //Check manifest file exist in document directory inside the course folder

                     //If it does not exist, then download the course folder inside document directory

                     //Read the manifest file from e.g DocumentDirectory/Norcat/CourseName

                     //Process the data for RijindaelDecoction

                     //Check if Course is already downloaded then read the data from manifest.xc
                     checkManifestFileExists(courseData.courseNameID)
                        .then(exists => {
                           //To do play the video from file system on mac
                           if (exists) {
                              readManifestFile(
                                 JSON.parse(JSON.stringify(loginCourse)),
                              );
                           } else {
                              isFoldeExistsAtDocumentDirecotory('Norcat')
                                 .then(folderExists => {
                                    if (folderExists) {
                                       //RNFS code
                                       //Download the zip file into the document directory

                                       const filePath =
                                          RNFS.DocumentDirectoryPath +
                                          '/Norcat/' +
                                          name;
                                       logger('path:', filePath);

                                       RNFS.downloadFile({
                                          fromUrl: url,
                                          toFile: filePath,
                                          background: true,
                                          discretionary: true,
                                          begin: res => {
                                             logger('Response begin ===\n\n');
                                             logger(res);
                                          },
                                          progress: res => {
                                             // Handle download progress updates if needed
                                             if (!isFileDownloaded) {
                                                logger('res', res);
                                                const current_progress =
                                                   Math.floor(
                                                      (res.bytesWritten /
                                                         res.contentLength) *
                                                         100,
                                                   );
                                                if (
                                                   current_progress >
                                                   downloadProgressRef.current
                                                ) {
                                                   logger(
                                                      `Current Progress: ${current_progress}% Prev progress: ${downloadProgressRef.current}`,
                                                   );
                                                   // previous_progress = current_progress;
                                                   setProgress(
                                                      current_progress,
                                                   );
                                                   if (
                                                      current_progress == 100
                                                   ) {
                                                      logger('100%');
                                                      setIsFileDownloaded(true);
                                                   }
                                                }
                                             }
                                          },
                                       })
                                          .promise.then(response => {
                                             setIsFileDownloaded(true);
                                             logger(
                                                'File downloaded!',
                                                response,
                                             );
                                             //Unzip the file at documentdirectory using native moduels code
                                             if (isWindows) {
                                                NativeModules.UnzipModule.UnzipFolder(
                                                   name,
                                                   RNFS.DocumentDirectoryPath,
                                                   'UTF-8',
                                                )
                                                   .then(() => {
                                                      logger("Login Course" + loginCourse);
                                                      readManifestFile(
                                                         JSON.parse(
                                                            JSON.stringify(
                                                               loginCourse,
                                                            ),
                                                         ),
                                                      );
                                                   })
                                                   .catch(error => {
                                                      alert(error);
                                                      console.error(
                                                         'Method failed with error:',
                                                         error,
                                                      );
                                                   });
                                             } else {
                                                NativeModules.DownloadModule.unzipFile(
                                                   name,
                                                   oncomplete => {
                                                      if (
                                                         oncomplete == 'success'
                                                      ) {
                                                         logger(
                                                            'compelete',
                                                            oncomplete,
                                                         );
                                                         readManifestFile(
                                                            loginCourse,
                                                         );
                                                      }
                                                   },
                                                );
                                             }
                                          })
                                          .catch(err => {
                                             logger('Download error:', err);
                                          });
                                    }
                                 })
                                 .catch(error => {
                                    logger.error('Error:', error);
                                 });
                           }
                        })
                        .catch(err => logger(err));
                  } else {
                     apiGetCourseList({
                        url: wwwCourse,
                        onResponse: response => {
                           if (response.status) {
                              dispatch(setCourseData(nCourseData));
                              logger('response.data::', response.data);
                              logger('nCourseData::', nCourseData);
                              const resData = RijindaelDecoction({
                                 dcrText: response.data,
                              });
                              if (resData.responseCode !== 0) {
                                 try {
                                    const modifyData = completeModuleEvaluation(
                                       {
                                          loginToCourse: loginCourse,
                                          courseDetails: resData.data,
                                       },
                                    );
                                    logger('modifyData::', modifyData);
                                    logger('loginCourse::', loginCourse);
                                    const unCompletedModule =
                                       CourseModuleCompletedCount({
                                          loginToCourse: loginCourse,
                                          courseDetails: resData.data,
                                       });
                                    dispatch(
                                       setModuleCompetedCount(
                                          unCompletedModule,
                                       ),
                                    );
                                    const x = JSON.parse(modifyData);
                                    if (
                                       Array.isArray(
                                          x.DataSet.courseModule.CourseModule,
                                       )
                                    ) {
                                       const mAvailable = ModuleAvailable({
                                          courseDetails: x,
                                       });
                                       if (Platform.OS === 'windows') {
                                          dispatch(
                                             setParseJsonData(mAvailable),
                                          );
                                       }
                                       setParseJson(mAvailable);
                                    } else {
                                       if (Platform.OS === 'windows') {
                                          dispatch(
                                             setParseJsonData(modifyData),
                                          );
                                       }
                                       setParseJson(modifyData);
                                    }
                                    setIsApiLoaded(false);
                                    if (
                                       modifyData &&
                                       firstNodeOfScrPad.length != 0
                                    ) {
                                       const selectedModuleIndex = {
                                          moduleIndex: 0,
                                       };
                                       dispatch(
                                          setModuleIndex(selectedModuleIndex),
                                       );
                                       // isRequiredFirstLunchToPlayerScreen({
                                       //    pData: modifyData,
                                       // });
                                    }
                                 } catch (error) {
                                    logger(error);
                                 }
                              } else {
                                 const message = resData.data;
                                 myIBTAlert({
                                    title: 'Error!',
                                    message: message,
                                    pCallBack: () => {
                                       navigation.goBack();
                                    },
                                 });
                              }
                           } else {
                              myIBTAlert({
                                 title: 'Error!',
                                 message: response.eMessage,
                                 pCallBack: () => {
                                    navigation.goBack();
                                 },
                              });
                           }
                        },
                        onProgressUpdate: percentage => {
                           logger(percentage, '%');
                           setProgress(percentage);
                        },
                     });
                  }
               } else {
                  let callbackType = null;
                  if (res?.ScratchPadRecordsList?.length === 0) {
                     res =
                        'Oops! something went wrong. Please login again to proceed.';
                     callbackType = 'TOKEN_EXPIRED';
                  }
                  if (isWeb) {
                     showTokenExpireAlertWeb(res, callbackType);
                  } else {
                     if (callbackType === 'TOKEN_EXPIRED') {
                        Alert.alert('Alert!', res, [
                           {
                              text: 'OK',
                              onPress: () => {
                                 const user = {
                                    isLoggedIn: false,
                                    userName: '',
                                 };
                                 setTimeout(() => {
                                    dispatch(setSignIn(user));
                                 }, 1000);
                              },
                           },
                        ]);
                     } else {
                        alert(res);
                     }
                  }
               }
            })
            .catch(err => logger(err));
         return () => {
            downloadEventListener.remove();
            progressEventListener.remove();
         };
      }
   }, [
      navigation,
      loginCourse,
      courseData,
      authData,
      isWindows ? null : dispatch,
   ]);
   function isRequiredFirstLunchToPlayerScreen({pData}) {
      const jsonData = JSON.parse(pData);
      let module, temModule;
      if (Array.isArray(jsonData?.DataSet.courseModule?.CourseModule)) {
         module = jsonData?.DataSet.courseModule?.CourseModule;
      } else {
         module = [jsonData?.DataSet.courseModule?.CourseModule];
      }
      logger('modulef ', 'Hellow');
      const pageNumber = isNewAPI
         ? firstNodeOfScrPad.ModulePageNumber
         : firstNodeOfScrPad.PageNumber;
      if (firstNodeOfScrPad && pageNumber === 0 && module != 'undefined') {
         const isPreTestEnable = canPreTest({cm: module[0]});
         navigation.navigate('ModulesSlidesContainer', {
            CourseModuleSlide: module[0].ModuleSlides.CourseModuleSlide,
            isModuleComplete: module[0].CourseModuleComplete,
            CourseModuleName: module[0].CourseModuleName,
            courseData: {
               courseNameID: courseData.courseNameID,
               coursename: courseData.coursename,
            },
            isPreTeastEnable: isPreTestEnable,
         });
      }
      setIsApiLoaded(false);
   }
   return (
      <SafeAreaView
         style={
            !isApiLoaded
               ? styles.container
               : [
                    styles.downloadContainer,
                    {
                       ...Platform.select({
                          web: {
                             flex: null,
                             height: '100%',
                             minHeight: '100vh',
                          },
                       }),
                    },
                 ]
         }>
         {!isApiLoaded && (
            <CustomStatusBar backgroundColor={drawerListBackgroundColor} />
         )}
         {isApiLoaded ? (
            <DownloadCourseScreen
               progressUpdate={progress}
               onExitClick={() => {
                  props.navigation.goBack();
               }}
            />
         ) : (
            <CourseDetails
               couseItem={courseData}
               parseJson={parseJson}
               onExitClick={() => {
                  props.navigation.goBack();
               }}
               onRowSelected={({item, pretest, index}) => {
                  //Navigate to Module details
                  //logger(item.CourseModuleComplete)
                  /*const sliceSize = currentModulePageNumber({
                     module: item,
                     srPad: loginCourse,
                  });
                  dispatch(
                     setModuleSlides(item.ModuleSlides.CourseModuleSlide),
                  );
                  dispatch(setCurrentRunningSlide(sliceSize));*/
                  const selectedModuleIndex = {moduleIndex: index};
                  dispatch(setModuleIndex(selectedModuleIndex));
                  dispatch(setCommingFromDetails(true));

                  const isPreTestEnable = canPreTest({cm: item}) && pretest;
                  props.navigation.navigate('ModulesSlidesContainer', {
                     CourseModuleSlide: item.ModuleSlides.CourseModuleSlide,
                     isModuleComplete: item.CourseModuleComplete,
                     CourseModuleName: item.CourseModuleName,
                     courseData: {
                        courseNameID: courseData.courseNameID,
                        coursename: courseData.coursename,
                     },
                     isPreTeastEnable: isPreTestEnable,
                     moduleIndex: index,
                  });
               }}
            />
         )}
      </SafeAreaView>
   );
};

const styles = StyleSheet.create({
   container: {
      flex: 1,
      // alignItems: 'center',
      // justifyContent: 'center',
      backgroundColor: drawerListBackgroundColor,
   },
   downloadContainer: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: downloadViewColor,
   },
});
